import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, Route, Router } from '@angular/router';

import { FeatureToggleService } from './feature-toggle.service';

export function featureToggleGuard(route: Route | ActivatedRouteSnapshot): boolean {
  const featureToggleService = inject(FeatureToggleService);
  const router = inject(Router);

  if (!route.data?.featureFlag) {
    throw new Error('Provide feature flag via route data.');
  }

  const hasAccess = featureToggleService.isEnabled(route.data.featureFlag);

  if (hasAccess) {
    return true;
  }

  if (route.data.redirectUrl) {
    router.navigateByUrl(route.data.redirectUrl);
  }

  return false;
}
